import md5 from 'js-md5';

var mix= function(dd,k1,k2,k3,k4){
    return md5(k3+md5(k1+dd+k2)+k4)
  }

export default {
    mix
  }


// WEBPACK FOOTER //
// ./src/vue/someData/workers.js